u.Toggle = class extends u.ForElement {
    /**
     *
     */
    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.addEventListener('click', (evt) => {
            /**
             * The super.$open method adds a click listener to document, so stopPropagation is required to keep 
             * that callback from overriding this event. 
             */            
            evt.stopPropagation();
            evt.preventDefault();
            this.$forElement.$toggle();
        });
    }
};
u.Toggle.register('u-toggle');
